/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/add-variable-1784387': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M14.71 7.29a1 1 0 00-1.42 0L11 9.59l-2.29-2.3a1 1 0 10-1.42 1.42L9.59 11l-2.3 2.29a1 1 0 000 1.42 1 1 0 001.42 0l2.29-2.3 2.29 2.3a1 1 0 001.42 0 1 1 0 000-1.42L12.41 11l2.3-2.29a1 1 0 000-1.42zM7 18a3 3 0 01-3-3V7a3 3 0 013-3 1 1 0 000-2 5 5 0 00-5 5v8a5 5 0 005 5 1 1 0 000-2zM18 7v6a1 1 0 002 0V7a5 5 0 00-5-5 1 1 0 000 2 3 3 0 013 3zm3 11h-1v-1a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2z"/>'
  }
})
